import { render, staticRenderFns } from "./myBrokerage.vue?vue&type=template&id=7fe60552&scoped=true"
import script from "./myBrokerage.vue?vue&type=script&lang=js"
export * from "./myBrokerage.vue?vue&type=script&lang=js"
import style0 from "./myBrokerage.vue?vue&type=style&index=0&id=7fe60552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe60552",
  null
  
)

export default component.exports